<template>
  <v-btn
    variant="text"
    color="error"
    prepend-icon="mdi-filter-remove-outline"
    :disabled="isDisabled"
    @click="$emit('cta-clicked')"
  >
    {{ ctaText }}
  </v-btn>
</template>

<script setup lang="ts">
type Props = {
  isDisabled?: boolean;
  ctaText?: string;
};

type Emits = {
  'cta-clicked': [];
};

defineProps<Props>();
defineEmits<Emits>();
</script>
